import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
    locales: ['en', 'de', 'fr', 'hu', 'nl'],
    defaultLocale: 'en',
    localePrefix: 'as-needed',
});
